export { CrossWordsGameCoreModule } from './cross-words-game-core.module';
export { CrossWordsGameSelectorComponent } from './cross-words-game-selector/cross-words-game-selector.component';
export { CrossWordsGameCoreService } from './cross-words-game-core.service';
export { ICrossWordsGame, ICrossWord } from './cross-words-game.interface';
